import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { splitFilename } from 'src/app/helpers/file-helpers';
import { FileTypeInfo, SupportedFileTypes } from 'src/app/models/file-type.models';

@Component({
  selector: 'tx-file-type-selector',
  templateUrl: './file-type-selector.component.html',
  styleUrls: ['./file-type-selector.component.scss'],
})
export class FiletypeDropdownComponent implements OnChanges {
  public fileTypes = SupportedFileTypes;

  private _fileName: string = '';

  // create an variable that is an input and has a get and set
  @Input()
  set fileName(value: string) {
    this._fileName = value;
    var result = splitFilename(this.fileName);
    this.baseFileName = result.name;
    if (this.baseExtension !== '.' + result.extension) {
      this.baseExtension = '.' + result.extension;
      this.selectedFileType =
        SupportedFileTypes.find((x) => x.extension == '.' + result.extension.toLowerCase()) || SupportedFileTypes[0];
    }
    this.fileNameChange.emit(this._fileName);
  }
  get fileName(): string {
    return this._fileName;
  }
  @Input() defaultFileType: FileTypeInfo | string = SupportedFileTypes[0];
  @Input() disableFileName: boolean = false;
  @Input() disableFileType: boolean = false;
  @Output() fileNameChange = new EventEmitter<string>();
  @Output() extensionChange = new EventEmitter<FileTypeInfo>();
  public selectedFileType: FileTypeInfo = SupportedFileTypes[0];
  public baseFileName: string = '';
  public baseExtension: string = '';

  ngOnInit() {
    var result = splitFilename(this.fileName);
    this.baseFileName = result.name;
    this.baseExtension = '.' + result.extension;
    this.setFileType();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['defaultFileType']) {
      this.setFileType();
    }
  }

  ngAfterViewInit() {
    if (this.fileName !== this.baseFileName + this.selectedFileType.extension) {
      this.fileName = this.baseFileName + this.selectedFileType.extension;
    }
    if (this.baseExtension !== this.selectedFileType.extension) {
      this.extensionChange.emit(this.selectedFileType);
    }
  }

  onFileTypeChange(selected: FileTypeInfo) {
    this.selectedFileType = selected;
    this.fileName = this.baseFileName + this.selectedFileType.extension;
    this.extensionChange.emit(selected);
  }

  onFileNameChange() {
    this.fileName = this.baseFileName + this.selectedFileType.extension;
  }

  private setFileType() {
    if (typeof this.defaultFileType === 'string') {
      this.selectedFileType =
        SupportedFileTypes.find((x) => x.extension === this.defaultFileType.toString().toLowerCase()) ||
        SupportedFileTypes[0];
    } else {
      this.selectedFileType = this.defaultFileType;
    }
  }
}
